@if (patient) {
  <div tuiCardLarge tuiSurface="elevated">
    <div class="row">
      <div class="col col-12">
        <div tuiHeader>
          <h1>
            <app-dossier-title-group
              [patient]="patient"
              [activite]="activite"
              [enCoursDeChargement]="false"
            />
          </h1>
        </div>

        <button
          type="button"
          id="demandes-contact"
          size="l"
          tuiButton
          (click)="openDialog()"
        >
          <tui-icon icon="@tui.message-circle" />
        </button>
        <button
          type="button"
          id="imprimer"
          size="l"
          tuiButton
          (click)="imprimer()"
        >
          <tui-icon icon="@tui.printer" />
        </button>
        <div>
          <p class="tui-space_bottom-4">NIR :{{ patient!.nir ?? undefined }}</p>
          <p class="tui-space_bottom-4">
            <span>{{ patient!.sexe }}</span> • Né le
            <span>{{ patient!.dateDeNaissance | date: "dd/MM/yyyy" }}</span>
          </p>
          <p>{{ patient!.adresse?.ligne1 ?? undefined }}</p>
          <p>{{ patient!.adresse?.ligne2 ?? undefined }}</p>
          <p>{{ patient!.adresse?.ligne3 ?? undefined }}</p>
          <p class="tui-space_bottom-4">
            {{ patient!.adresse?.codePostal ?? undefined }}
            {{ patient!.adresse?.ville ?? undefined }}

            @if (patient!.adresse?.pays) {
              ({{ patient!.adresse!.pays! }})
            }
          </p>
          <p class="tui-space_bottom-4">
            Téléphone :
            {{ patient!.mobile }}
            @if (patient!.mobile && patient!.telephone) {
              ;
            }
            {{ patient!.telephone }}
          </p>
          <p>
            Appareillé le
            {{
              patient.patientComplement?.dateInstallation | date: "dd/MM/yyyy"
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div tuiCardLarge tuiSurface="elevated">
    <div class="row">
      <div class="col col-12">
        <div tuiHeader>
          <h1>
            <app-dossier-title-group [enCoursDeChargement]="false" />
          </h1>
        </div>
        <div>
          <p class="tui-space_bottom-4">
            NIR : <span class="placeholder">000000000000000</span>
          </p>
          <p class="tui-space_bottom-4">
            <span class="placeholder">Xxxxx</span> • Né le
            <span class="placeholder">00/00/0000</span>
          </p>
          <p class="placeholder">00 XXX XXXXXXX XX XXXXXX</p>
          <p class="placeholder"></p>
          <p class="placeholder tui-space_bottom-4">00000 XXXXX</p>
          <p class="tui-space_bottom-4">
            Téléphone : <span class="placeholder">00.00.00.00.00</span>
          </p>
          <p>Appareillé le <span class="placeholder">00/00/0000</span></p>
        </div>
      </div>
    </div>
  </div>
}
